
(function($, visceral) {

    if(visceral == null) {
        window.visceral = visceral = {}; 
    }

    $(function() {
        init();
    })

    function init() {
        $('.solutions-image__pin').on('click touch', function() {
            $(this).toggleClass('solutions-image__pin--active');
            $('.solutions-image__pin--active').not(this).removeClass('solutions-image__pin--active');
        })
    }
    

})(jQuery, window.visceral);


// WEBPACK FOOTER //
// ./scripts/solutions-image.js